import { type Editor, EditorContent } from "@tiptap/react";
import { type ReactNode } from "react";

interface EditorContentWrapperProps {
  children?: ReactNode;
  editor: Editor | null;
  id: string;
  tabIndex?: number;
}

export const EditorContentWrapper = (props: EditorContentWrapperProps) => {
  const { editor, children, id, tabIndex } = props;

  return (
    <div
      tabIndex={tabIndex}
      // Only when this wrapper itself is tabbed into: focus bubbles up from
      // children, and tiptap's focus() lands a frame later via rAF — so a node
      // view's popover or modal would lose focus right after opening.
      onFocus={(e) => {
        if (e.target !== e.currentTarget) return;
        editor?.chain().focus(undefined, { scrollIntoView: false }).run();
      }}
    >
      <EditorContent editor={editor} id={id} />
      {children}
    </div>
  );
};
